'use client';

import { useEffect } from 'react';

export default function CustomCssInjector() {
  useEffect(() => {
    const fetchAndInjectCSS = async () => {
      try {
        const response = await fetch('/api/settings');
        if (response.ok) {
          const data = await response.json();
          if (data.customCss && data.customCss.trim() !== '') {
            // Remove existing custom CSS if any
            const existingStyle = document.getElementById('custom-css-override');
            if (existingStyle) {
              existingStyle.remove();
            }

            // Inject new custom CSS
            const style = document.createElement('style');
            style.id = 'custom-css-override';
            style.textContent = data.customCss;
            document.head.appendChild(style);
          }
        }
      } catch (error) {
        console.error('Error fetching custom CSS:', error);
      }
    };

    fetchAndInjectCSS();
  }, []);

  return null; // This component doesn't render anything
}
